<script lang="ts">
    import { fade } from "svelte/transition";
    import type { WorkAdventureComponent } from "../../../../types/component";
    import { createFloatingUiActions } from "../../../Utils/svelte-floatingui";

    interface Props {
        headerText?: string;
        descriptionText?: string;
        img?: string | WorkAdventureComponent;
        style?: string;
        disabled?: boolean;
        onclick?: (event: MouseEvent) => void;
        testId?: string;
    }

    let { headerText, descriptionText, img, style, disabled = false, onclick, testId }: Props = $props();

    let isHovered = $state(false);

    const [floatingUiRef, floatingUiContent, arrowAction] = createFloatingUiActions(
        {
            placement: "bottom",
        },
        12,
    );

    let hoverTimeout: ReturnType<typeof setTimeout> | undefined;

    function onMouseEnter() {
        hoverTimeout = setTimeout(() => {
            isHovered = true;
        }, 400);
    }

    function onMouseLeave() {
        isHovered = false;
        if (hoverTimeout) {
            clearTimeout(hoverTimeout);
            hoverTimeout = undefined;
        }
    }
</script>

<button
    onmouseenter={onMouseEnter}
    onmouseleave={onMouseLeave}
    class="add-property-button tooltip relative m-[0.25rem_0.125rem] flex flex-col items-center justify-center rounded-[9px]
    border border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-raised)] p-3 text-[var(--nutrivera-shell-muted)] hover:border-[var(--nutrivera-shell-accent)] hover:bg-[var(--nutrivera-shell-hover)] hover:text-[var(--nutrivera-shell-text)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--nutrivera-shell-accent)] disabled:opacity-50"
    use:floatingUiRef
    data-testid={testId}
    {style}
    onclick={(event) => {
        if (disabled) return;
        onclick?.(event);
    }}
    {disabled}
>
    <div class="w-8 h-8 flex flex-wrap items-center justify-center" style={disabled ? `opacity: 0.5;` : ""}>
        {#if typeof img === "string"}
            <img draggable="false" class="max-w-[75%] max-h-[75%]" src={img} alt="info icon" />
        {:else if img !== undefined}
            {@const Image = img}
            <Image class="text-[var(--nutrivera-shell-text)]" font-size="20" />
        {/if}
    </div>
</button>

{#if isHovered}
    <div
        class="tooltiptext absolute z-[310] max-w-full rounded-[9px] border border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-bg)] p-2 text-xs text-[var(--nutrivera-shell-text)] shadow-[0_6px_8px_rgb(7_17_28/28%)]"
        use:floatingUiContent
        transition:fade={{ duration: 200 }}
    >
        <div use:arrowAction></div>
        <p class="text-sm m-0 font-semibold">{headerText}</p>
        {descriptionText}
    </div>
{/if}

<style>
    .tooltip {
        position: relative;
        display: inline-block;
    }

    .add-property-button {
        display: flex;
    }

    button:disabled {
        pointer-events: all;
        cursor: default;

        div {
            cursor: default;
        }

        img {
            opacity: 0.5;
            cursor: default;
        }
    }
</style>
